import * as bowser from 'bowser';
import { AfterViewInit, ChangeDetectionStrategy, Component, Injector, Input, OnInit } from '@angular/core';

import { BaseComponent } from '../../base.component';
import { NgSwitch } from '@angular/common';
import { LayoutService } from '../../../Services/layout/layout.service';
import { ActionApiService } from 'src/app/Services/action-api/action-api.service';
import { ChatbotService } from 'src/app/Services/chatbot-service/chatbot.service';

@Component({
	selector: 'talk-with-us',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<div [ngSwitch]="control.attributes.type">
			<div id="TTM_True_SAC_True_CHAT_True" class="option1" *ngSwitchCase="'TTM_True_SAC_True_CHAT_True'">
				<h1>So many ways to connect</h1>
				<p>Call us or we'll call you. You can even chat with one of our licensed insurance experts right now!</p>
				<div class="ways-to-connect">
					<a
						[href]="dialNumber"
						class="phone-number"
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="{{ labelPrefix }}_PGRNumber"
						value="{{ control.attributes.phoneNumber }}"
						action="LinkClick"
						attributeVal="phone"
					>
						{{ control.attributes.phoneNumber }}
					</a>
					<span class="vsep">&nbsp;|&nbsp;</span>
					<a tabindex="0" class="chat-with-us" (click)="openChatOnClick()"> Chat with us now </a>
				</div>
				<hr />
				<span>You choose when we call</span>
				<div class="call-me both">
					<control
						gtmEvents="click"
						gtmHandlerType="button"
						gtmAction="ButtonClick"
						[control]="control.attributes.buttonCallNow"
						context="popup"
					></control>
					<control [control]="control.attributes.buttonCallMeLater" context="popup"></control>
				</div>
			</div>

			<div id="TTM_True_SAC_False_CHAT_True" class="option13" *ngSwitchCase="'TTM_True_SAC_False_CHAT_True'">
				<h1>So many ways to connect</h1>
				<p>Call us or we'll call you. You can even chat with one of our licensed insurance experts right now!</p>
				<a
					[href]="dialNumber"
					class="phone-number"
					gtm-handler
					events="click"
					handlerType="dataValue"
					label="{{ labelPrefix }}_PGRNumber"
					value="{{ control.attributes.phoneNumber }}"
					action="LinkClick"
					attributeVal="phone"
				>
					{{ control.attributes.phoneNumber }}
				</a>
				<span class="vsep">&nbsp;|&nbsp;</span>
				<a tabindex="0" class="chat-with-us" (click)="openChatOnClick()"> Chat with us now </a>
				<hr />
				<div class="call-me now">
					<control
						gtmEvents="click"
						gtmHandlerType="button"
						gtmAction="ButtonClick"
						[control]="control.attributes.buttonCallNow"
						context="popup"
					></control>
				</div>
			</div>

			<div id="TTM_False_SAC_True_CHAT_True" class="option2" *ngSwitchCase="'TTM_False_SAC_True_CHAT_True'">
				<h1>So many ways to connect</h1>
				<p>Call us or we'll call you. You can even chat with one of our licensed insurance experts right now!</p>

				<div class="ways-to-connect">
					<a
						[href]="dialNumber"
						class="phone-number"
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="{{ labelPrefix }}_PGRNumber"
						value="{{ control.attributes.phoneNumber }}"
						action="LinkClick"
						attributeVal="phone"
					>
						{{ control.attributes.phoneNumber }}
					</a>
					<span class="vsep">&nbsp;|&nbsp;</span>
					<a tabindex="0" class="chat-with-us" (click)="openChatOnClick()"> Chat with us now </a>
				</div>
				<hr />
				<span>Schedule a call for later on</span>
				<div class="call-me later">
					<control
						gtmEvents="click"
						gtmHandlerType="button"
						gtmAction="ButtonClick"
						[control]="control.attributes.buttonCallLater"
						context="popup"
					></control>
				</div>
			</div>

			<div id="TTM_True_SAC_True_CHAT_False" class="option19" *ngSwitchCase="'TTM_True_SAC_True_CHAT_False'">
				<h1>So many ways to connect</h1>
				<p>Call us or we'll call you. One of our licensed home insurance experts is standing by ready to help.</p>
				<div class="ways-to-connect">
					<a
						[href]="dialNumber"
						class="phone-number"
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="{{ labelPrefix }}_PGRNumber"
						value="{{ control.attributes.phoneNumber }}"
						action="LinkClick"
					>
						{{ control.attributes.phoneNumber }}
					</a>
				</div>
				<hr />
				<span>You choose when we call</span>
				<div class="call-me both">
					<control
						gtm-handler
						events="click"
						handlerType="button"
						label="{{ labelPrefix }}_Call_Me_Now"
						action="ButtonClick"
						[control]="control.attributes.buttonCallNow"
						context="popup"
					></control>
					<control [control]="control.attributes.buttonCallMeLater" context="popup"></control>
				</div>
			</div>

			<div id="TTM_False_SAC_True_CHAT_False" class="option9" *ngSwitchCase="'TTM_False_SAC_True_CHAT_False'">
				<h1>Let's connect later on</h1>
				<span>We'll call you when our experts are available</span>
				<div class="call-me later">
					<control [control]="control.attributes.bigButtonCallLater" context="popup"></control>
				</div>
				<hr />
				<section class="availability-times">
					<div class="give-us-a-call">
						<span>Or give us a call when<br />we're in</span><br />
						<a
							[href]="dialNumber"
							class="phone-number"
							gtm-handler
							events="click"
							handlerType="dataValue"
							label="{{ labelPrefix }}_PGRNumber"
							value="{{ control.attributes.phoneNumber }}"
							action="LinkClick"
						>
							{{ control.attributes.phoneNumber }}</a
						>
					</div>
					<div class="work-hours">
						<table>
							<tbody>
								<tr *ngFor="let item of control.attributes.workHours">
									<td>
										{{ item.day }}
									</td>
									<td>{{ item.hour }} {{ 'ET' }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
			</div>

			<div id="TTM_True_SAC_False_CHAT_False" class="option19" *ngSwitchCase="'TTM_True_SAC_False_CHAT_False'">
				<h1>So many ways to connect</h1>
				<p>Call us or we'll call you. One of our licensed home insurance experts is standing by ready to help.</p>
				<div class="ways-to-connect">
					<a
						[href]="dialNumber"
						class="phone-number"
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="{{ labelPrefix }}_PGRNumber"
						value="{{ control.attributes.phoneNumber }}"
						action="LinkClick"
					>
						{{ control.attributes.phoneNumber }}
					</a>
				</div>
				<hr />
				<div class="call-me now">
					<control
						gtm-handler
						events="click"
						handlerType="button"
						label="{{ labelPrefix }}_Call_Me_Now"
						action="ButtonClick"
						[control]="control.attributes.buttonCallNow"
						context="popup"
					></control>
				</div>
			</div>

			<div id="TTM_False_SAC_False_CHAT_True" class="option8" *ngSwitchCase="'TTM_False_SAC_False_CHAT_True'">
				<h1>So many ways to connect</h1>
				<p>Give us a call or chat with one of our licensed home insurance experts right now!</p>
				<div class="ways-to-connect">
					<a
						[href]="dialNumber"
						class="phone-number"
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="{{ labelPrefix }}_PGRNumber"
						value="{{ control.attributes.phoneNumber }}"
						action="LinkClick"
					>
						{{ control.attributes.phoneNumber }}
					</a>
					<span class="vsep">&nbsp;|&nbsp;</span>
					<a tabindex="0" class="chat-with-us" (click)="openChatOnClick()"> Chat with us now </a>
				</div>
			</div>

			<div
				id="TTM_False_SAC_False_CHAT_False_PAA_True"
				class="option10"
				*ngSwitchCase="'TTM_False_SAC_False_CHAT_False_PAA_True'"
			>
				<h1>Give us a call</h1>
				<p>Speak with a licensed home insurance expert now!</p>
				<a
					[href]="dialNumber"
					class="phone-number"
					gtm-handler
					attr.gtm="{{ labelPrefix }}_PGRNumber"
					events="click"
					handlerType="dataValue"
					label="{{ labelPrefix }}_PGRNumber"
					value="{{ control.attributes.phoneNumber }}"
					action="LinkClick"
				>
					{{ control.attributes.phoneNumber }}
				</a>
			</div>

			<div
				id="TTM_False_SAC_False_CHAT_False_PAA_False"
				class="option20"
				*ngSwitchCase="'TTM_False_SAC_False_CHAT_False_PAA_False'"
			>
				<h1>Let's connect later on</h1>
				<p>Give us a call when we're in</p>
				<section class="availability-times">
					<div class="give-us-a-call">
						<a
							[href]="dialNumber"
							class="phone-number"
							gtm-handler
							attr.gtm="{{ labelPrefix }}_PGRNumber"
							events="click"
							handlerType="dataValue"
							label="{{ labelPrefix }}_PGRNumber"
							value="{{ control.attributes.phoneNumber }}"
							action="LinkClick"
						>
							{{ control.attributes.phoneNumber }}
						</a>
					</div>

					<div class="work-hours">
						<table>
							<tbody>
								<tr *ngFor="let item of control.attributes.workHours">
									<td>
										{{ item.day }}
									</td>
									<td>{{ item.hour }} {{ 'ET' }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
			</div>

			<div id="Enter_Phone_1" class="option17" *ngSwitchCase="'Enter_Phone_1'">
				<h1>What's your phone number?</h1>
				<p>Simply enter your phone number and we'll give you a call.</p>
				<div class="input-number">
					<control
						gtm-handler
						events="click"
						handlerType="dataValue"
						label="{{ labelPrefix }}2_Enter_Phone_1"
						action="TextBoxFocus"
						[control]="control.attributes.inputPhoneNumber"
						context="popup"
					></control>
					<control
						gtm-handler
						events="click"
						handlerType="button"
						label="{{ labelPrefix }}2_Call_Me_Now"
						action="ButtonClick"
						[control]="control.attributes.buttonCallNow"
						context="popup"
					></control>
				</div>
			</div>

			<div id="Enter_Phone_2" class="option4" *ngSwitchCase="'Enter_Phone_2'">
				<h1>What's your phone number?</h1>
				<p>Simply enter your phone number and we'll give you a call later on.</p>
				<div class="input-number">
					<control [control]="control.attributes.inputPhoneNumber" context="popup"></control>
					<control [control]="control.attributes.buttonCallLater" context="popup"></control>
				</div>
			</div>

			<div id="Select_Date_Time" class="SchedulePanel" *ngSwitchCase="'Select_Date_Time'">
				<h1>Select a time for us to call</h1>
				<p>Our experts will contact you between the following hours (EST).</p>
				<control [control]="control.attributes.schedulePanel" context="popup"></control>
			</div>

			<div id="We_Are_Calling" class="option6" *ngSwitchCase="'We_Are_Calling'">
				<h1>We’re calling now</h1>
				<p>Keep your phone line open. No worries if you miss our call.</p>
				<control [control]="control.attributes.callRequestLink" context="popup"></control>
			</div>

			<div id="Call_Scheduled" class="option5" *ngSwitchCase="'Call_Scheduled'">
				<h1>Your call is scheduled</h1>
				<p>
					One of our home insurance experts will call you
					<span>{{ control.attributes.scheduledDate.date }}</span>
					between
					<span class="mobile-block">{{ control.attributes.scheduledDate.hour }}</span>
				</p>
			</div>

			<div id="TTM_Offline" class="option7" *ngSwitchCase="'TTM_Offline'">
				<h1>Call me now is currently unavailable</h1>
				<p>Please call us. One of our licensed home insurance experts is standing by ready to help.</p>
				<a
					[href]="dialNumber"
					class="phone-number"
					gtm-handler
					attr.gtm="{{ labelPrefix }}_PGRNumber"
					events="click"
					handlerType="dataValue"
					label="{{ labelPrefix }}_PGRNumber"
					value="{{ control.attributes.phoneNumber }}"
					action="LinkClick"
				>
					{{ control.attributes.phoneNumber }}
				</a>
			</div>

			<div id="SAC_Offline" class="option16" *ngSwitchCase="'SAC_Offline'">
				<h1>Schedule a call is currently unavailable</h1>
				<p>Please call us. One of our licensed home insurance experts is standing by ready to help.</p>
				<div class="call-us">
					<a
						[href]="dialNumber"
						class="phone-number"
						gtm-handler
						attr.gtm="{{ labelPrefix }}_PGRNumber"
						events="click"
						type="dataValue"
						label="{{ labelPrefix }}_PGRNumber"
						value="{{ control.attributes.phoneNumber }}"
						action="LinkClick"
					>
						{{ control.attributes.phoneNumber }}
					</a>
				</div>
			</div>

			<div id="Time_No_Available" class="option14" *ngSwitchCase="'Time_No_Available'">
				<h1>That time is no longer available</h1>
				<p>Please select a different time.</p>
				<control [control]="control.attributes.schedulePanel" context="popup"></control>
			</div>

			<div id="GiveUsCall" class="option18" *ngSwitchCase="'GiveUsCall'">
				<h1>Give us a call</h1>
				<p class="speakwithus">Speak with a licensed home insurance expert now!</p>
				<section class="availability-times">
					<div class="give-us-a-call">
						<a
							[href]="dialNumber"
							class="phone-number"
							gtm-handler
							attr.gtm="{{ labelPrefix }}_PGRNumber"
							events="click"
							handlerType="dataValue"
							label="{{ labelPrefix }}_PGRNumber"
							value="{{ control.attributes.phoneNumber }}"
							action="LinkClick"
						>
							{{ control.attributes.phoneNumber }}</a
						>
					</div>
					<div class="work-hours">
						<table>
							<tbody>
								<tr *ngFor="let item of control.attributes.workHours">
									<td>
										{{ item.day }}
									</td>
									<td>{{ item.hour }} {{ 'ET' }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
			</div>

			<!-- CHAT -->
			<div class="ChatWithUsNow" *ngSwitchCase="'ChatWithUsNow'">
				<h1>Chat with us now!</h1>
				<p>Our licensed home insurance experts are standing by to answer your questions.</p>
				<div class="input-number">
					<control [control]="control.attributes.inputFirstName" context="popup"></control>
					<control [control]="control.attributes.buttonChatNow" context="popup"></control>
				</div>
			</div>

			<!-- END CHAT -->

			<!-- UNUSED -->
			<div class="option12" *ngSwitchCase="'12'">
				<h1>Give us a call</h1>
				<p>Speak with a licensed home insurance expert now!</p>
				<a
					[href]="dialNumber"
					class="phone-number"
					gtm-handler
					attr.gtm="{{ labelPrefix }}_PGRNumber"
					events="click"
					handlerType="dataValue"
					label="{{ labelPrefix }}_PGRNumber"
					value="{{ control.attributes.phoneNumber }}"
					action="LinkClick"
				>
					{{ control.attributes.phoneNumber }}
				</a>
			</div>

			<div class="option15" *ngSwitchCase="'15'">
				<h1>So many ways to connect</h1>
				<p>Call us or we'll call you. you can even chat with one of our licensed insurance experts right now!</p>
				<div class="contact-us">
					<a
						[href]="dialNumber"
						class="phone-number"
						gtm-handler
						attr.gtm="{{ labelPrefix }}_PGRNumber"
						events="click"
						handlerType="dataValue"
						label="{{ labelPrefix }}_PGRNumber"
						value="{{ control.attributes.phoneNumber }}"
						action="LinkClick"
					>
						{{ control.attributes.phoneNumber }}
					</a>
					<p tabindex="0" class="chat-with-us">Chat with us now</p>
				</div>
				<hr />
				<div class="call-me now">
					<control [control]="control.attributes.bigButtonCallNow" context="popup"></control>
					<div></div>
				</div>
			</div>

			<!--<div class="option" *ngSwitchCase="">
<h1>Give us a call</h1>
<p>Speak with a licensed home insurance expert now</p>
<a [href]="dialNumber" class="phone-number">
  {{ control.attributes.phoneNumber }}
</a>
</div> -->
			<!-- END UNUSED -->
		</div>
	`,
	styleUrls: ['./talk-with-us.component.scss'],
})
export class TalkWithusComponent extends BaseComponent implements OnInit, AfterViewInit {
	dialNumber: any;
	shouldShowCallMeNow: boolean = false;
	labelPrefix: string = 'Popup.GetHelp';

	constructor(
		injector: Injector,
		private LayoutService: LayoutService,
		private actionApiService: ActionApiService,
		private chatbotService: ChatbotService
	) {
		super(injector);
	}

	ngOnInit() {
		const globalAttributes = this.storeService.getGlobalAttributes();

		this.LayoutService.staticLayout.subscribe((data) => {
			if (data && data.data && data.data.globalAttributes) {
				this.shouldShowCallMeNow = !!data.data.globalAttributes.shouldShowCallMeNow;
			}
		});
		if (
			this.control.attributes.type.indexOf('TTM_False_SAC_False_CHAT_False') === -1 &&
			this.control.attributes.type.indexOf('TTM') !== -1 &&
			this.control.attributes.type.indexOf('SAC') !== -1 &&
			this.control.attributes.type.indexOf('CHAT') !== -1
		) {
			this.control.attributes.type = this.control.attributes.type.substring(
				0,
				this.control.attributes.type.indexOf('_PAA')
			);
		}
		this.dialNumber = 'tel:' + this.control.attributes.phoneNumber;

		// if mobile hide chat
		let isMobile =
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';
		if (isMobile) {
			this.control.attributes.type = this.control.attributes.type.replace('CHAT_True', 'CHAT_False');
		}
	}
	ngAfterViewInit() {
		var dataObj = {
			event: 'GAEvent',
			eventCategory: 'Home_Quoting',
			eventAction: 'Display',
			eventLabel: this.labelPrefix,
			eventValue: '',
			callback: '',
			nonInteraction: 'nonInteraction',
		};

		let bothCallsElem = this.elementRef.nativeElement.querySelector('.both');
		let laterCallsElem = this.elementRef.nativeElement.querySelector('.later');
		let nowCallsElem = this.elementRef.nativeElement.querySelector('.now');
		let callMeNowClicked = this.elementRef.nativeElement.querySelector('.input-number');
		let SchedulePanelEelem = this.elementRef.nativeElement.querySelector('.SchedulePanel ');

		if (bothCallsElem) {
			dataObj['callmenow'] = true;
			dataObj['callmelater'] = true;
		} else if (laterCallsElem) {
			dataObj['callmelater'] = true;
		} else if (nowCallsElem) {
			dataObj['callmenow'] = true;
		} else if (SchedulePanelEelem) {
			dataObj.eventLabel = 'Popup.CallmeLater';
		} else if (callMeNowClicked) {
			dataObj.eventLabel = 'Popup.CallmeNow';
		}
	}

	// open chat in a resizable window when clicking on 'Chat with us'
	openChatOnClick() {
		const globalAttributes = this.storeService.getGlobalAttributes();
		if (globalAttributes && globalAttributes.chatBotAuth) {
			this.storeService.closePopup();
			this.chatbotService.showDialog();
		} else {
			const chatUrl = this.control.attributes['chatUrl'];
			const requestBody: request = {
				data: { chatUrl },
				info: {
					action: 'chatClicked',
					conditions: '',
					elementSrc: '',
					stage: '',
					notRenderPage: false,
				},
			};
			this.actionApiService.invokeAction(requestBody);

			window.open(chatUrl, '_blank', 'width=600,height=475,scrollbars=yes');
		}
		return false;
	}
}
